import clsx from 'clsx'

const SearchTabSection = ({ tabs, activeTab, setActiveTab, setSearchTab }) => {
  return (
    <>
      {tabs.map(({ flag, label }, index) => (
        <li
          key={index}
          className={clsx(
            'border-navy-300/50 flex-1/2 border-b py-16',
            activeTab === flag && 'border-b-4 !border-black !font-bold'
          )}
          onClick={() => {
            setActiveTab(flag)
            setSearchTab(flag)
          }}
        >
          {label}
        </li>
      ))}
    </>
  )
}

export default SearchTabSection
